import GlobalFeed from '@/components/community/GlobalFeed.vue';
import { mountCommunityComponentAsApp } from '@/entrypoints/shared/community-mounter';

mountCommunityComponentAsApp(GlobalFeed, '#community-feed-container').catch(
  console.error
);
